module.exports = "https://web-assets.ifttt.com/packs/media/pro_monthly_to_annual/mobile-f9f0c286.svg";